import { render, staticRenderFns } from "./paymentSuccess.vue?vue&type=template&id=89648c02&scoped=true"
import script from "./paymentSuccess.vue?vue&type=script&lang=js"
export * from "./paymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./paymentSuccess.vue?vue&type=style&index=0&id=89648c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89648c02",
  null
  
)

export default component.exports